/**
 * 在线缴费路由配置
 */
export default {
  path: '/home/online-pay/:id',
  name: 'online-pay',
  component: () => import('iebdc/views/online-pay'),
  meta: {
    label: '在线缴费',
    permission: 'IEBDC:SY:ZXJF',
    construction: 'IEBDC:SY:ZXJF:SFZJ'
  }
};
